__turbopack_context__.v({
  "disclaimer_web3": "CybiRW_disclaimer_web3",
  "input": "CybiRW_input",
  "inputGroup_web3": "CybiRW_inputGroup_web3",
  "label": "CybiRW_label",
  "namesRow_web3": "CybiRW_namesRow_web3",
  "selectControl": "CybiRW_selectControl",
  "selectGroup_web3": "CybiRW_selectGroup_web3",
  "selectLabel": "CybiRW_selectLabel",
  "submit": "CybiRW_submit",
  "textAreaGroup_web3": "CybiRW_textAreaGroup_web3",
});
